<template>
	<NP-Modal
		:label="order.sub_type === 'cash_from_cashdesk' && action !== 'cancel' ? titleText : null"
		:class="{ 'cashdesk-action-modal': true, red: cancel }"
		:toggle="toggle"
		:variant="isConfirmCashFromCashdesk || isForceClose ? 'sidebar' : 'modal'"
	>
		<form @submit.prevent="apply" class="container">
			<div>
				<div
					:class="{
						'order-info': true,
						'cash-to-cashdesk': order.sub_type === 'cash_to_cashdesk' || action === 'cancel',
						'cash-from-cashdesk': order.sub_type === 'cash_from_cashdesk' && action !== 'cancel'
					}"
					:sub-type="order.sub_type"
				>
					<div v-if="order.sub_type === 'cash_to_cashdesk' || action === 'cancel'">
						<div :class="imageClass" />
						<h3 :class="{ red: cancel }">
							{{ titleText }}
						</h3>
					</div>
					<NP-Avatar
						v-else
						:title="`${cashdesk.user_first_name} ${cashdesk.user_last_name}`"
						class="avatar"
						:user="{
							first_name: cashdesk.user_first_name,
							last_name: cashdesk.user_last_name
						}"
						hide-text
					/>
					<p class="text" v-html="text" />
					<div v-if="!cancel" class="balance">
						<p v-if="inputDisabled">{{ fact_amount }}</p>
						<NP-Input
							v-else
							:error="fieldErrors.amount || fieldErrors.fact_amount"
							type="monetary"
							v-model="fact_amount"
						/>
					</div>
				</div>
				<div v-if="isConfirmCashFromCashdesk || isForceClose" class="banknotes-wrap">
					<NP-Banknotes
						v-model="cash"
						:banknote-denominations="banknoteDenominations"
						:coin-denominations="coinDenominations"
						:banknotes-error="fieldErrors.cash || fieldErrors.fact_amount"
						:lists="lists"
					/>
				</div>
			</div>
			<div class="buttons">
				<NP-Button class="cancel-btn" @click="toggle"> Скасувати </NP-Button>
				<NP-Button type="submit" priority="high" class="confirm-btn" :loading="loading">Підтвердити</NP-Button>
			</div>
		</form>
	</NP-Modal>
</template>

<script>
import { validation } from 'novapay-ui';
import find from 'lodash/find';
import capitalize from 'lodash/capitalize';

import cashdeskActionTypes from './store/cashdesk-action-types';
import { enum as subTypes } from '@repo/enums/cashbook-order-sub-types';
import { enum as banknoteDenominations } from '@repo/enums/banknote-denominations';
import { enum as coinDenominations } from '@repo/enums/coin-denominations';

export default {
	name: 'CashdeskActionModal',
	props: {
		toggle: { type: Function, default: null },
		createCashToCashdesk: { type: Function, default: null },
		confirmCashToCashdesk: { type: Function, default: null },
		confirmCashFromCashdesk: { type: Function, default: null },
		cancelCreatedOrder: { type: Function, default: null },
		forceCloseCashdeskShift: { type: Function, default: null },
		cashdesk: { type: Object, default: null },
		lists: { type: Object, default: null },
		order: { type: Object, default: null },
		user: { type: Object, default: null },
		action: {
			type: String,
			validator: (v) => Object.values(cashdeskActionTypes).includes(v),
			default: null
		},
		loadingActions: { type: Array, default: () => [] },
		validationErrors: { type: Array, default: () => [] }
	},
	data() {
		return {
			banknoteDenominations,
			coinDenominations,
			fact_amount: this.order.recorded_amount,
			cash: null
		};
	},
	methods: {
		apply() {
			let cash = {
				banknotes: this.cash?.banknotes?.length ? this.cash.banknotes : null,
				coins: this.cash?.coins?.length ? this.cash.coins : null
			};
			return this.submitAction({
				amount: this.fact_amount,
				recipient_user_id: this.cashdesk.user_id,
				order: this.order,
				user_id: this.user.id,
				cash,
				cashdesk: this.cashdesk,

				loadingAction: true
			});
		}
	},
	computed: {
		titleText() {
			let actionMap = {
				[cashdeskActionTypes.create]: 'Створити',
				[cashdeskActionTypes.forceClose]: 'Створити',
				[cashdeskActionTypes.confirm]: 'Підтвердити',
				[cashdeskActionTypes.cancel]: 'Скасувати'
			};
			let orderType = find(this.lists['cashbook-order-types'], { id: this.order.type }).text;
			let additionText =
				(this.order.sub_type === subTypes.cashFromCashdesk && ' з другорядної каси') ||
				(this.order.sub_type === subTypes.cashToCashdesk && ' на другорядну касу') ||
				'';
			return `${actionMap[this.action]} ${orderType.toUpperCase()}${
				this.order.sub_type === 'cash_from_cashdesk' && this.action !== 'cancel' ? additionText : ''
			}`;
		},
		text() {
			if (this.cancel) {
				return `
					<p class="gray-40">
						Ви впевнені, що бажаєте відмінити ордер?
					</p>
				`;
			}
			let action = find(this.lists['cashbook-order-sub-types'], { id: this.order.sub_type }).text;
			let code = this.cashdesk.cash_machine_code;
			let actionText = `${capitalize(action)}${code ? `, РРО ${code},` : ''}`;
			let userName = `${this.cashdesk.user_first_name} ${this.cashdesk.user_last_name}`;
			return `
				<p class="gray-40">
					${actionText} зміна <b class="gray-50">${userName}</b> на суму:
				</p>
			`;
		},
		submitAction() {
			if (this.action === cashdeskActionTypes.cancel) {
				return this.cancelCreatedOrder;
			}
			if (this.isForceClose) {
				return this.forceCloseCashdeskShift;
			}
			let submitMap = {
				create_cash_to_cashdesk: this.createCashToCashdesk,
				confirm_cash_to_cashdesk: this.confirmCashToCashdesk,
				confirm_cash_from_cashdesk: this.confirmCashFromCashdesk
			};
			let key = `${this.action}_${this.order.sub_type}`;
			return submitMap[key];
		},
		imageClass() {
			return {
				img: true,
				bill: !this.cancel,
				cancel: this.cancel
			};
		},
		loading() {
			return (
				this.loadingActions.includes('createCashToCashdesk') ||
				this.loadingActions.includes('confirmCashToCashdesk') ||
				this.loadingActions.includes('confirmCashFromCashdesk') ||
				this.loadingActions.includes('forceCloseCashdeskShift') ||
				this.loadingActions.includes('cancelCreatedOrder')
			);
		},
		cancel() {
			return this.action === cashdeskActionTypes.cancel;
		},
		create() {
			return this.action === cashdeskActionTypes.create;
		},
		confirm() {
			return this.action === cashdeskActionTypes.confirm;
		},
		isConfirmCashFromCashdesk() {
			return this.confirm && this.order.sub_type === subTypes.cashFromCashdesk;
		},
		isForceClose() {
			return this.action === cashdeskActionTypes.forceClose;
		},
		fieldErrors() {
			return validation.computeValidationMessages(this.validationErrors, ['fact_amount', 'amount']);
		},
		inputDisabled() {
			return (
				this.create ||
				this.isForceClose ||
				(this.confirm && [subTypes.cashToCashdesk, subTypes.cashFromCashdesk].includes(this.order.sub_type))
			);
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/variables.scss';
@import '@assets/scss/mixins.scss';
$img-bill: '~@assets/images/img-bill.svg';
$img-cancel: '~@assets/images/img-cancel.svg';

.cashdesk-action-modal {
	::v-deep .modal-container {
		display: flex;
		flex-direction: column;
		border-top: 2px solid $gray-50;
		& .modal-body {
			padding-top: 0;
			height: 100%;
		}
	}
	.container {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		.order-info {
			display: flex;
			align-items: center;
			&.cash-to-cashdesk {
				flex-direction: column;
				h3 {
					text-align: center;
					margin-top: 16px;
				}
				.text {
					text-align: center;
					max-width: 340px;
					margin: 12px auto 0;
				}
				.bill {
					background: url($img-bill);
				}
				.cancel {
					background: url($img-cancel);
					height: 50px !important;
				}
				.img {
					width: 118px;
					height: 72px;
					background-size: contain;
					background-repeat: no-repeat;
					margin: 0 auto;
				}
				.balance {
					margin: 16px auto 10px auto;
				}
			}
			&.cash-from-cashdesk {
				margin-top: 15px;
				::v-deep .avatar {
					width: 32px;
					height: 32px;
					margin-right: 12px;
					span {
						margin-top: 9px;
						width: 32px;
						height: 32px;
					}
				}
				p {
					max-width: 330px;
					padding-right: 5px;
				}
				@include mobile() {
					flex-direction: column;
					text-align: center;
					justify-content: center;
					align-items: center;
					.avatar {
						margin: 0 0 5px 0;
					}
					p {
						margin-bottom: 10px;
					}
				}
			}
			::v-deep .balance {
				flex-shrink: 0;
				display: flex;
				width: 168px;
				height: 40px;
				background-color: $gray-5;
				border-radius: $border-radius;
				color: $gray-50;
				align-items: center;
				justify-content: center;
				& span {
					margin: 2px 0 0 2px;
				}
				& p {
					font-family: Proxima Nova Semibold;
					&::before {
						content: '₴ ';
						font-size: 15px;
						font-family: Montserrat;
					}
				}
			}
		}
		::v-deep .banknotes-wrap {
			display: flex;
			margin-top: 16px;
			width: 540px;
			.bills,
			.coins {
				justify-content: flex-start;
			}
			.bills {
				height: 225px;
			}
			.coins {
				height: 135px;
			}
			.bill,
			.coin {
				margin-bottom: 8px;
			}
		}
		.buttons {
			display: flex;
			justify-content: space-between;
			margin-top: 16px;
		}
	}
}
.red {
	::v-deep .modal-container {
		border-top: 2px solid $red;
		& .modal-header .title h3 {
			color: $red;
		}
	}
}
</style>
